import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const BookOpen = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M30.507 6.3848C30.3601 6.28745 26.8589 4 22.6964 4C19.5014 4 16.6979 5.34695 15.5 6.0174C14.3021 5.34695 11.4986 4 8.30357 4C4.14127 4 0.640067 6.28745 0.492955 6.3848C0.184893 6.58871 0 6.93219 0 7.3V24.9C0 25.5075 0.495723 26 1.10714 26C1.32677 26 1.5309 25.9357 1.70306 25.8261C1.70306 25.8261 4.92997 23.8 8.30357 23.8C11.6578 23.8 14.9062 25.8273 14.9062 25.8273C15.0779 25.9361 15.2812 26 15.5 26C15.7188 26 15.9232 25.9358 16.0952 25.8265C16.0952 25.8265 19.3228 23.8 22.6964 23.8C26.0507 23.8 29.2974 25.8273 29.2974 25.8273C29.4692 25.9363 29.6738 26 29.8929 26C30.5043 26 31 25.5075 31 24.9V7.3C31 6.93219 30.815 6.58871 30.507 6.3848ZM14.3929 23.0726C12.9288 22.4007 10.6843 21.6 8.30357 21.6C5.9228 21.6 3.67834 22.4007 2.21429 23.0726V7.92301C3.21791 7.36435 5.63051 6.2 8.30357 6.2C10.9615 6.2 13.3856 7.36669 14.3929 7.92466V23.0726ZM16.6071 23.0726V7.92301C17.6108 7.36435 20.0234 6.2 22.6964 6.2C25.3544 6.2 27.7785 7.36669 28.7857 7.92466V23.0726C27.3217 22.4007 25.0772 21.6 22.6964 21.6C20.3157 21.6 18.0712 22.4007 16.6071 23.0726Z" />
	</svg>
);

export default BookOpen;
